import { Controller } from '@hotwired/stimulus';

// Popover for the "X / Y entreprises contributrices" stat card on the
// compte prorata page État. Click-toggles a 2-column panel listing the
// included + excluded contracts.
//
// Targets:
//   trigger — the clickable stat card / button (currently informational).
//   panel   — the popover container that toggles `hidden`.
//
// Close on outside-click via the document-level click listener wired in
// `connect()` — Stimulus's per-action targeting can't see clicks landing
// outside `data-controller="prorata-contributors-popover"`.
export default class extends Controller {
  static targets = ['panel', 'trigger'];

  connect() {
    this.boundOutsideClick = this.outsideClick.bind(this);
    document.addEventListener('click', this.boundOutsideClick);
  }

  disconnect() {
    document.removeEventListener('click', this.boundOutsideClick);
  }

  toggle(event) {
    event.stopPropagation();
    this.panelTarget.classList.toggle('hidden');
  }

  hide() {
    this.panelTarget.classList.add('hidden');
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }
}
